import { render, staticRenderFns } from "./Assigned.vue?vue&type=template&id=3c2ee00a&"
import script from "./Assigned.vue?vue&type=script&lang=ts&"
export * from "./Assigned.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports